import { render, staticRenderFns } from "./VenueStorages.vue?vue&type=template&id=581be2d4&scoped=true&"
import script from "./VenueStorages.vue?vue&type=script&lang=js&"
export * from "./VenueStorages.vue?vue&type=script&lang=js&"
import style0 from "./VenueStorages.vue?vue&type=style&index=0&id=581be2d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581be2d4",
  null
  
)

export default component.exports